import { subDays, addDays } from "date-fns";
const createMinDate = (date, days) => {
  return date instanceof Date && typeof days === "number" ? subDays(date, days) : void 0;
};
const createMaxDate = (date, days) => {
  return date instanceof Date && typeof days === "number" ? addDays(date, days) : void 0;
};
export {
  createMaxDate,
  createMinDate
};
//# sourceMappingURL=create-dates.js.map
